import React, { Fragment, useEffect } from "react";
import { Pagina } from "../template/Template";
import { AuthContext } from "../../App";
import { ThemeProvider } from "@material-ui/core/styles";
import { format } from "date-fns";
import { Button } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import {
    DataGrid,
    GridToolbarContainer,
    GridFilterToolbarButton,
} from "@material-ui/data-grid";
import { Formik } from "formik";
import { Loading } from "../Loading";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ptBR2 from "date-fns/locale/pt-BR";
import {
    findEntradasXSaidas,
    findTempoMedioAnalise,
    findTempoMedioVeredito,
    findDivergenciaVeredito,
    findDivergenciaIa,
    findProdutividade,
    findOperadores,
} from "../../services/KpiService";

import { usuarioFindAll } from "../../services/UsuarioService";

import { ShowMessageBox } from "../ShowMessageBox";

import { useStyles } from "../styles/StyleKpi";
import { theme } from "../styles/Theme";

var MS_PER_DAY = 60000 * 60 * 24;

let severity = "success";
let msg = "";

export default function Kpi() {
    const classes = useStyles();
    const { state: authState } = React.useContext(AuthContext);

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`tabpanel-${index}`}
                aria-labelledby={`tab-${index}`}
                {...other}
            >
                {value === index && <div p={2}>{children}</div>}
            </div>
        );
    }

    const Content = () => {
        const [list, setList] = React.useState([]);
        const [listUsuarios, setListUsuarios] = React.useState([]);
        const [openLoading, setOpenLoading] = React.useState(false);
        const [openSnackBar, setOpenSnackBar] = React.useState(false);
        const [value, setValue] = React.useState(0);

        //        const ExcelFile = ReactExport.ExcelFile;
        //        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        //        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        useEffect(() => {
            usuarioFindAll().then((resp) => {
                setListUsuarios(resp.data);
            });
        }, []);

        const CustomToolbar = () => {
            return (
                <GridToolbarContainer>
                    <GridFilterToolbarButton />
                    {/* <GridDensitySelector /> */}
                </GridToolbarContainer>
            );
        };
        /*
    +--------------------------------------------------------------------------------+ 
    |                           Tab Entrada X Saidas                                 |
    +--------------------------------------------------------------------------------+
    */

        const TabEntradaXSaidas = () => {
            return (
                <Formik
                    initialValues={{
                        dataInicial: new Date(new Date().getTime() - 30 * MS_PER_DAY),
                        dataFinal: new Date(),
                    }}
                    validate={(values) => {
                        const errors = {};
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue }) => {
                        setOpenSnackBar(false);

                        let dtif;
                        let dtff;
                        if (values.dataInicial.getTime() > values.dataFinal.getTime()) {
                            severity = "error";
                            msg = "Data inicial maior que data final";
                            setOpenSnackBar(true);
                            return;
                        } else {
                            dtif = format(values.dataInicial, "yyyy-MM-dd") + "'T'00:00:00";
                            dtff = format(values.dataFinal, "yyyy-MM-dd") + "'T'23:59:59";

                            setOpenLoading(true);
                            const respList = await findEntradasXSaidas(dtif, dtff);
                            setList(respList.data);
                            setOpenLoading(false);
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form onSubmit={handleSubmit} className={classes.form}>
                            <div className={classes.boxCenter}>
                                <Paper className={classes.box} elevation={7}>
                                    <Loading open={openLoading} />
                                    <ShowMessageBox
                                        open={openSnackBar}
                                        setOpen={setOpenSnackBar}
                                        severity={severity}
                                        msg={msg}
                                    />
                                    <div className={classes.dashboard_header}>
                                        {/* <div className={classes.center_data_1}>
                      <div>
                        <div>
                          <h2 style={{ color: "white" }}>Entradas X Saídas</h2>
                        </div>
                        <div>
                          <h3 style={{ color: "white" }}>
                            <HourglassEmptyIcon /> Listar Por
                          </h3>
                        </div>
                      </div>
                    </div> */}

                                        <div className={classes.center_data_2}>
                                            <div className={classes.center_data}>
                                                <div>
                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            id="dataInicial"
                                                            name="dataInicial"
                                                            value={values.dataInicial}
                                                            onChange={(val) => {
                                                                setFieldValue("dataInicial", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            value={values.dataFinal}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            id="dataFinal"
                                                            name="dataFinal"
                                                            onChange={(val) => {
                                                                setFieldValue("dataFinal", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        type="submit"
                                                        style={{ marginTop: "9px", fontWeight: "bold" }}
                                                    >
                                                        Filtrar
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.boxPrancheta}>
                                        <div className={classes.center_data}>
                                            {list.length === 0 ? (
                                                <div></div>
                                            ) : (
                                                <table style={{ border: "1px solid black" }}>
                                                    {list.map((option) => (
                                                        <tr>
                                                            <td
                                                                style={{
                                                                    background: "LightGray",
                                                                    width: "200px",
                                                                    fontSize: "150%",
                                                                }}
                                                            >
                                                                {option.subtipo}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    background: "LightGray",
                                                                    width: "90px",
                                                                    textAlign: "right",
                                                                    fontSize: "150%",
                                                                }}
                                                            >
                                                                {option.ocorrencias}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </table>
                                            )}
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        </form>
                    )}
                </Formik>
            );
        };

        /*
    +--------------------------------------------------------------------------------+ 
    |                       Tab Tempo Medio Analise                                  |
    +--------------------------------------------------------------------------------+
    */

        const TabTempoMedioAnalise = () => {
            return (
                <Formik
                    initialValues={{
                        usuario: "",
                        dataInicial: new Date(new Date().getTime() - 30 * MS_PER_DAY),
                        dataFinal: new Date(),
                    }}
                    validate={(values) => {
                        const errors = {};
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue }) => {
                        let dtif;
                        let dtff;
                        if (values.dataInicial.getTime() > values.dataFinal.getTime()) {
                            severity = "error";
                            msg = "Data inicial maior que data final";
                            setOpenSnackBar(true);
                            return;
                        } else {
                            dtif = format(values.dataInicial, "yyyy-MM-dd");
                            dtff = format(values.dataFinal, "yyyy-MM-dd");

                            setOpenLoading(true);
                            const respList = await findTempoMedioAnalise(
                                values.usuario === "" ? "-1" : values.usuario,
                                dtif,
                                dtff
                            );
                            console.log(respList.data);
                            setList(respList.data);
                            setOpenLoading(false);
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form onSubmit={handleSubmit} className={classes.form}>
                            <div className={classes.boxCenter}>
                                <Paper className={classes.box} elevation={7}>
                                    <Loading open={openLoading} />
                                    <ShowMessageBox
                                        open={openSnackBar}
                                        setOpen={setOpenSnackBar}
                                        severity={severity}
                                        msg={msg}
                                    />
                                    <div className={classes.dashboard_header}>
                                        {/* <div className={classes.center_data_1}>
                      <div>
                        <div>
                          <h2 style={{ color: "white" }}>
                            Tempo Médio Analise
                          </h2>
                        </div>
                        <div>
                          <h3 style={{ color: "white" }}>
                            <HourglassEmptyIcon /> Listar Por
                          </h3>
                        </div>
                      </div>
                    </div> */}

                                        <div className={classes.center_data_2}>
                                            <div className={classes.center_data}>
                                                <div className={classes.center_data}>
                                                    <InputLabel
                                                        id="label-usuarios"
                                                        style={{ marginRight: "20px" }}
                                                    >
                                                        Operadores
                                                    </InputLabel>
                                                    <Select
                                                        labelId="label-usuarios"
                                                        id="usuario"
                                                        name="usuario"
                                                        value={values.opeId}
                                                        style={{
                                                            width: "250px",
                                                            marginRight: "20px",
                                                            marginLeft: "10px",
                                                        }}
                                                        onChange={handleChange}
                                                    >
                                                        {listUsuarios.map((option) => (
                                                            <MenuItem
                                                                key={option.usu_id}
                                                                value={option.usu_id}
                                                            >
                                                                {option.usu_apelido}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>

                                                    {/* <span style={{ marginRight: "20px" }}>Período:</span> */}
                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            id="dataInicial"
                                                            name="dataInicial"
                                                            value={values.dataInicial}
                                                            onChange={(val) => {
                                                                setFieldValue("dataInicial", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            value={values.dataFinal}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            id="dataFinal"
                                                            name="dataFinal"
                                                            onChange={(val) => {
                                                                setFieldValue("dataFinal", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        type="submit"
                                                        style={{ marginTop: "9px", fontWeight: "bold" }}
                                                    >
                                                        Filtrar
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.boxPrancheta}>
                                        <div className={classes.center_data}>
                                            {list.length === 0 ? (
                                                <div></div>
                                            ) : (
                                                <table style={{ border: "1px solid black" }}>
                                                    <tr>
                                                        <td
                                                            colSpan="4"
                                                            style={{
                                                                background: "Yellow",
                                                                width: "90px",
                                                                textAlign: "center",
                                                                fontSize: "150%",
                                                            }}
                                                        >
                                                            Tempo Medio Analise
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                background: "LightGray",
                                                                width: "90px",
                                                                textAlign: "center",
                                                                fontSize: "150%",
                                                            }}
                                                        >
                                                            {list.dias}(dias)
                                                        </td>
                                                        <td
                                                            style={{
                                                                background: "LightGray",
                                                                width: "120px",
                                                                textAlign: "center",
                                                                fontSize: "150%",
                                                            }}
                                                        >
                                                            {list.horas}(horas)
                                                        </td>
                                                        <td
                                                            style={{
                                                                background: "LightGray",
                                                                width: "120px",
                                                                textAlign: "center",
                                                                fontSize: "150%",
                                                            }}
                                                        >
                                                            {list.minutos}(minutos)
                                                        </td>
                                                        <td
                                                            style={{
                                                                background: "LightGray",
                                                                width: "120px",
                                                                textAlign: "center",
                                                                fontSize: "150%",
                                                            }}
                                                        >
                                                            {list.segundos}(segundos)
                                                        </td>
                                                    </tr>
                                                </table>
                                            )}
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        </form>
                    )}
                </Formik>
            );
        };

        /*
    +--------------------------------------------------------------------------------+ 
    |                         Tempo Médio de Um Veredito                             |
    +--------------------------------------------------------------------------------+
    */

        const TabTempoMedioVeredito = () => {
            return (
                <Formik
                    initialValues={{
                        usuario: "",
                        dataInicial: new Date(new Date().getTime() - 30 * MS_PER_DAY),
                        dataFinal: new Date(),
                    }}
                    validate={(values) => {
                        const errors = {};
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue }) => {
                        setOpenSnackBar(false);

                        let dtif;
                        let dtff;
                        if (values.dataInicial.getTime() > values.dataFinal.getTime()) {
                            severity = "error";
                            msg = "Data inicial maior que data final";
                            setOpenSnackBar(true);
                            return;
                        } else {
                            dtif = format(values.dataInicial, "yyyy-MM-dd") + "'T'00:00:00";
                            dtff = format(values.dataFinal, "yyyy-MM-dd") + "'T'23:59:59";

                            setOpenLoading(true);
                            const respList = await findTempoMedioVeredito(
                                values.usuario === "" ? "-1" : values.usuario,
                                dtif,
                                dtff
                            );
                            console.log(respList.data);
                            setList(respList.data);
                            setOpenLoading(false);
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form onSubmit={handleSubmit} className={classes.form}>
                            <div className={classes.boxCenter}>
                                <Paper className={classes.box} elevation={7}>
                                    <Loading open={openLoading} />
                                    <ShowMessageBox
                                        open={openSnackBar}
                                        setOpen={setOpenSnackBar}
                                        severity={severity}
                                        msg={msg}
                                    />
                                    <div className={classes.dashboard_header}>
                                        {/* <div className={classes.center_data_1}>
                      <div>
                        <div>
                          <h2 style={{ color: "white" }}>
                            Tempo Médio Veredito
                          </h2>
                        </div>
                        <div>
                          <h3 style={{ color: "white" }}>
                            <HourglassEmptyIcon /> Listar Por
                          </h3>
                        </div>
                      </div>
                    </div> */}

                                        <div className={classes.center_data_2}>
                                            <div className={classes.center_data}>
                                                <div className={classes.center_data}>
                                                    <InputLabel
                                                        id="label-usuarios"
                                                        style={{ marginRight: "20px" }}
                                                    >
                                                        Operadores
                                                    </InputLabel>
                                                    <Select
                                                        labelId="label-usuarios"
                                                        id="usuario"
                                                        name="usuario"
                                                        value={values.opeId}
                                                        style={{
                                                            width: "250px",
                                                            marginRight: "20px",
                                                            marginLeft: "10px",
                                                        }}
                                                        onChange={handleChange}
                                                    >
                                                        {listUsuarios.map((option) => (
                                                            <MenuItem
                                                                key={option.usu_id}
                                                                value={option.usu_id}
                                                            >
                                                                {option.usu_apelido}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>

                                                    {/* <span style={{ marginRight: "20px" }}>Período:</span> */}
                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            id="dataInicial"
                                                            name="dataInicial"
                                                            value={values.dataInicial}
                                                            onChange={(val) => {
                                                                setFieldValue("dataInicial", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            value={values.dataFinal}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            id="dataFinal"
                                                            name="dataFinal"
                                                            onChange={(val) => {
                                                                setFieldValue("dataFinal", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        type="submit"
                                                        style={{ marginTop: "9px", fontWeight: "bold" }}
                                                    >
                                                        Filtrar
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.boxPrancheta}>
                                        <div className={classes.center_data}>
                                            {list.length === 0 ? (
                                                <div></div>
                                            ) : (
                                                <table style={{ border: "1px solid black" }}>
                                                    <tr>
                                                        <td
                                                            colSpan="4"
                                                            style={{
                                                                background: "Yellow",
                                                                width: "90px",
                                                                textAlign: "center",
                                                                fontSize: "150%",
                                                            }}
                                                        >
                                                            Tempo Médio Veredito
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                background: "LightGray",
                                                                width: "90px",
                                                                textAlign: "center",
                                                                fontSize: "150%",
                                                            }}
                                                        >
                                                            {list.dias}(dias)
                                                        </td>
                                                        <td
                                                            style={{
                                                                background: "LightGray",
                                                                width: "120px",
                                                                textAlign: "center",
                                                                fontSize: "150%",
                                                            }}
                                                        >
                                                            {list.horas}(horas)
                                                        </td>
                                                        <td
                                                            style={{
                                                                background: "LightGray",
                                                                width: "120px",
                                                                textAlign: "center",
                                                                fontSize: "150%",
                                                            }}
                                                        >
                                                            {list.minutos}(minutos)
                                                        </td>
                                                        <td
                                                            style={{
                                                                background: "LightGray",
                                                                width: "120px",
                                                                textAlign: "center",
                                                                fontSize: "150%",
                                                            }}
                                                        >
                                                            {list.segundos}(segundos)
                                                        </td>
                                                    </tr>
                                                </table>
                                            )}
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        </form>
                    )}
                </Formik>
            );
        };

        /*
    +--------------------------------------------------------------------------------+ 
    |                  Tab Divergencia de Veredito                                   |
    +--------------------------------------------------------------------------------+
    */

        const TabDivergenciaVeredito = () => {
            return (
                <Formik
                    initialValues={{
                        usuario: "",
                        dataInicial: new Date(new Date().getTime() - 30 * MS_PER_DAY),
                        dataFinal: new Date(),
                    }}
                    validate={(values) => {
                        const errors = {};
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue }) => {
                        setOpenSnackBar(false);

                        let dtif;
                        let dtff;
                        if (values.dataInicial.getTime() > values.dataFinal.getTime()) {
                            severity = "error";
                            msg = "Data inicial maior que data final";
                            setOpenSnackBar(true);
                            return;
                        } else {
                            dtif = format(values.dataInicial, "yyyy-MM-dd") + "'T'00:00:00";
                            dtff = format(values.dataFinal, "yyyy-MM-dd") + "'T'23:59:59";

                            setOpenLoading(true);
                            const respList = await findDivergenciaVeredito(
                                values.usuario === "" ? "-1" : values.usuario,
                                dtif,
                                dtff
                            );
                            console.log(respList);
                            if (respList.data[0].total === null) {
                                respList.data[0].total = 0;
                            }
                            setList(respList.data[0]);
                            setOpenLoading(false);
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form onSubmit={handleSubmit} className={classes.form}>
                            <div className={classes.boxCenter}>
                                <Paper className={classes.box} elevation={7}>
                                    <Loading open={openLoading} />
                                    <ShowMessageBox
                                        open={openSnackBar}
                                        setOpen={setOpenSnackBar}
                                        severity={severity}
                                        msg={msg}
                                    />
                                    <div className={classes.dashboard_header}>
                                        <div className={classes.center_data_1}>
                                            {/* <div>
                        <div>
                          <h2 style={{ color: "white" }}>
                            Divergência Veredito
                          </h2>
                        </div>
                        <div>
                          <h3 style={{ color: "white" }}>
                            <HourglassEmptyIcon /> Listar Por
                          </h3>
                        </div>
                      </div> */}
                                        </div>

                                        <div className={classes.center_data_2}>
                                            <div className={classes.center_data}>
                                                <div className={classes.center_data}>
                                                    <InputLabel
                                                        id="label-usuarios"
                                                        style={{ marginRight: "20px" }}
                                                    >
                                                        Operadores
                                                    </InputLabel>
                                                    <Select
                                                        labelId="label-usuarios"
                                                        id="usuario"
                                                        name="usuario"
                                                        value={values.opeId}
                                                        style={{
                                                            width: "250px",
                                                            marginRight: "20px",
                                                            marginLeft: "10px",
                                                        }}
                                                        onChange={handleChange}
                                                    >
                                                        {listUsuarios.map((option) => (
                                                            <MenuItem
                                                                key={option.usu_id}
                                                                value={option.usu_id}
                                                            >
                                                                {option.usu_apelido}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    {/* <span style={{ marginRight: "20px" }}>Período:</span> */}
                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            id="dataInicial"
                                                            name="dataInicial"
                                                            value={values.dataInicial}
                                                            onChange={(val) => {
                                                                setFieldValue("dataInicial", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            value={values.dataFinal}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            id="dataFinal"
                                                            name="dataFinal"
                                                            onChange={(val) => {
                                                                setFieldValue("dataFinal", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        type="submit"
                                                        style={{ marginTop: "9px", fontWeight: "bold" }}
                                                    >
                                                        Filtrar
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.boxPrancheta}>
                                        <div className={classes.center_data}>
                                            {list.length === 0 ? (
                                                <div></div>
                                            ) : (
                                                <table style={{ border: "1px solid black" }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                background: "Yellow",
                                                                width: "300px",
                                                                textAlign: "center",
                                                                fontSize: "150%",
                                                            }}
                                                        >
                                                            Vereditos Divergentes
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                background: "LightGray",
                                                                width: "300px",
                                                                textAlign: "center",
                                                                fontSize: "150%",
                                                            }}
                                                        >
                                                            {list.total}
                                                        </td>
                                                    </tr>
                                                </table>
                                            )}
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        </form>
                    )}
                </Formik>
            );
        };

        /*
    +--------------------------------------------------------------------------------+ 
    |                          Tab Divergencia IA                                    |
    +--------------------------------------------------------------------------------+
    */

        const TabDivergenciaIA = () => {
            return (
                <Formik
                    initialValues={{
                        usuario: "",
                        dataInicial: new Date(new Date().getTime() - 30 * MS_PER_DAY),
                        dataFinal: new Date(),
                    }}
                    validate={(values) => {
                        const errors = {};
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue }) => {
                        setOpenSnackBar(false);

                        let dtif;
                        let dtff;
                        if (values.dataInicial.getTime() > values.dataFinal.getTime()) {
                            severity = "error";
                            msg = "Data inicial maior que data final";
                            setOpenSnackBar(true);
                            return;
                        } else {
                            dtif = format(values.dataInicial, "yyyy-MM-dd") + "'T'00:00:00";
                            dtff = format(values.dataFinal, "yyyy-MM-dd") + "'T'23:59:59";

                            setOpenLoading(true);
                            const respList = await findDivergenciaIa(
                                values.usuario === "" ? "-1" : values.usuario,
                                dtif,
                                dtff
                            );
                            setList(respList.data);
                            setOpenLoading(false);
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form onSubmit={handleSubmit} className={classes.form}>
                            <div className={classes.boxCenter}>
                                <Paper className={classes.box} elevation={7}>
                                    <Loading open={openLoading} />
                                    <ShowMessageBox
                                        open={openSnackBar}
                                        setOpen={setOpenSnackBar}
                                        severity={severity}
                                        msg={msg}
                                    />
                                    <div className={classes.dashboard_header}>
                                        {/* <div className={classes.center_data_1}>
                      <div>
                        <div>
                          <h2 style={{ color: "white" }}>
                            Divergência Veredito IA
                          </h2>
                        </div>
                        <div>
                          <h3 style={{ color: "white" }}>
                            <HourglassEmptyIcon /> Listar Por
                          </h3>
                        </div>
                      </div>
                    </div> */}

                                        <div className={classes.center_data_2}>
                                            <div className={classes.center_data}>
                                                <div className={classes.center_data}>
                                                    <InputLabel
                                                        id="label-usuarios"
                                                        style={{ marginRight: "20px" }}
                                                    >
                                                        Operadores
                                                    </InputLabel>
                                                    <Select
                                                        labelId="label-usuarios"
                                                        id="usuario"
                                                        name="usuario"
                                                        value={values.opeId}
                                                        style={{
                                                            width: "250px",
                                                            marginRight: "20px",
                                                            marginLeft: "10px",
                                                        }}
                                                        onChange={handleChange}
                                                    >
                                                        {listUsuarios.map((option) => (
                                                            <MenuItem
                                                                key={option.usu_id}
                                                                value={option.usu_id}
                                                            >
                                                                {option.usu_apelido}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    <span style={{ marginRight: "20px" }}>Período:</span>
                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            id="dataInicial"
                                                            name="dataInicial"
                                                            value={values.dataInicial}
                                                            onChange={(val) => {
                                                                setFieldValue("dataInicial", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            value={values.dataFinal}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            id="dataFinal"
                                                            name="dataFinal"
                                                            onChange={(val) => {
                                                                setFieldValue("dataFinal", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        type="submit"
                                                        style={{ marginTop: "9px", fontWeight: "bold" }}
                                                    >
                                                        Filtrar
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.boxPrancheta}>
                                        <div className={classes.boxDataGrid}>
                                            <ThemeProvider theme={theme}>
                                                <DataGrid
                                                    rows={list}
                                                    disableColumnMenu
                                                    disableColumnReorder
                                                    disableSelectionOnClick
                                                    pageSize={8}
                                                    rowHeight={30}
                                                    components={{
                                                        Toolbar: CustomToolbar,
                                                    }}
                                                    columns={[
                                                        {
                                                            field: "container",
                                                            headerName: "Container",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 200,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "trk_id",
                                                            headerName: "Truck ID",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 200,
                                                        },
                                                        {
                                                            field: "sit_id",
                                                            headerName: "Site",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 100,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "analise_ia",
                                                            headerName: "Analise IA",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "veredito_porto",
                                                            headerName: "Ver.Porto",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 100,
                                                            sortable: false,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "analise_operador",
                                                            headerName: "Analise Operador",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "veredito_operador",
                                                            headerName: "Ver.Operador",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            sortable: false,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "analise_supervisor",
                                                            headerName: "Analise Supervisor",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "veredito_supervisor",
                                                            headerName: "Ver.Supervisor",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 147,
                                                            sortable: false,
                                                            align: "center",
                                                        },
                                                    ]}
                                                />
                                            </ThemeProvider>
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        </form>
                    )}
                </Formik>
            );
        };

        /*
    +--------------------------------------------------------------------------------+ 
    |                       Tab Relatorio Operadores                                 |
    +--------------------------------------------------------------------------------+
    */

        const TabRelatorioOperadores = () => {
            return (
                <Formik
                    initialValues={{
                        usuario: "",
                        dataInicial: new Date(new Date().getTime() - 30 * MS_PER_DAY),
                        dataFinal: new Date(),
                    }}
                    validate={(values) => {
                        const errors = {};
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue }) => {
                        setOpenSnackBar(false);

                        let dtif;
                        let dtff;
                        if (values.dataInicial.getTime() > values.dataFinal.getTime()) {
                            severity = "error";
                            msg = "Data inicial maior que data final";
                            setOpenSnackBar(true);
                            return;
                        } else {
                            dtif = format(values.dataInicial, "yyyy-MM-dd") + "'T'00:00:00";
                            dtff = format(values.dataFinal, "yyyy-MM-dd") + "'T'23:59:59";

                            setOpenLoading(true);
                            const respList = await findOperadores(
                                values.usuario === "" ? "-1" : values.usuario,
                                dtif,
                                dtff
                            );
                            setList(respList.data);
                            setOpenLoading(false);
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form onSubmit={handleSubmit} className={classes.form}>
                            <div className={classes.boxCenter}>
                                <Paper className={classes.box} elevation={7}>
                                    <Loading open={openLoading} />
                                    <ShowMessageBox
                                        open={openSnackBar}
                                        setOpen={setOpenSnackBar}
                                        severity={severity}
                                        msg={msg}
                                    />
                                    <div className={classes.dashboard_header}>
                                        {/* <div className={classes.center_data_1}>
                      <div>
                        <div>
                          <h2 style={{ color: "white" }}>
                            Relatório de Operadores
                          </h2>
                        </div>
                        <div>
                          <h3 style={{ color: "white" }}>
                            <HourglassEmptyIcon /> Listar Por
                          </h3>
                        </div>
                      </div>
                    </div> */}

                                        <div className={classes.center_data_2}>
                                            <div className={classes.center_data}>
                                                <div className={classes.center_data}>
                                                    <InputLabel
                                                        id="label-usuarios"
                                                        style={{ marginRight: "20px" }}
                                                    >
                                                        Operadores
                                                    </InputLabel>
                                                    <Select
                                                        labelId="label-usuarios"
                                                        id="usuario"
                                                        name="usuario"
                                                        value={values.opeId}
                                                        style={{
                                                            width: "250px",
                                                            marginRight: "20px",
                                                            marginLeft: "10px",
                                                        }}
                                                        onChange={handleChange}
                                                    >
                                                        {listUsuarios.map((option) => (
                                                            <MenuItem
                                                                key={option.usu_id}
                                                                value={option.usu_id}
                                                            >
                                                                {option.usu_apelido}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    {/* <span style={{ marginRight: "20px" }}>Período:</span> */}
                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            id="dataInicial"
                                                            name="dataInicial"
                                                            value={values.dataInicial}
                                                            onChange={(val) => {
                                                                setFieldValue("dataInicial", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            value={values.dataFinal}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            id="dataFinal"
                                                            name="dataFinal"
                                                            onChange={(val) => {
                                                                setFieldValue("dataFinal", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        type="submit"
                                                        style={{ marginTop: "9px", fontWeight: "bold" }}
                                                    >
                                                        Filtrar
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.boxPrancheta}>
                                        <div className={classes.boxDataGridOperadores}>
                                            <ThemeProvider theme={theme}>
                                                <DataGrid
                                                    rows={list}
                                                    disableColumnMenu
                                                    disableColumnReorder
                                                    rowHeight={30}
                                                    pageSize={8}
                                                    disableSelectionOnClick
                                                    components={{
                                                        Toolbar: CustomToolbar,
                                                    }}
                                                    columns={[
                                                        {
                                                            field: "apelido",
                                                            headerName: "Usuário",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 200,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "data_conclusao",
                                                            headerName: "Data",
                                                            headerClassName: "header_grid",
                                                            type: "date",
                                                            headerAlign: "center",
                                                            width: 148,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "veu_situacao",
                                                            headerName: "Veredito",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 170,
                                                        },
                                                        {
                                                            field: "total_situacao",
                                                            headerName: "Vereditos",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 110,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "total_geral",
                                                            headerName: "Total",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "percentual",
                                                            headerName: "%",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 120,
                                                            sortable: false,
                                                            align: "center",
                                                        },
                                                    ]}
                                                />
                                            </ThemeProvider>
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        </form>
                    )}
                </Formik>
            );
        };

        /*
    +--------------------------------------------------------------------------------+ 
    |                               Tab Produtividade                                |
    +--------------------------------------------------------------------------------+
    */

        const TabProdutividade = () => {
            return (
                <Formik
                    initialValues={{
                        usuario: "",
                        dataInicial: new Date(new Date().getTime() - 30 * MS_PER_DAY),
                        dataFinal: new Date(),
                    }}
                    validate={(values) => {
                        const errors = {};
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue }) => {
                        setOpenSnackBar(false);

                        let dtif;
                        let dtff;
                        if (values.dataInicial.getTime() > values.dataFinal.getTime()) {
                            severity = "error";
                            msg = "Data inicial maior que data final";
                            setOpenSnackBar(true);
                            return;
                        } else {
                            dtif = format(values.dataInicial, "yyyy-MM-dd") + "'T'00:00:00";
                            dtff = format(values.dataFinal, "yyyy-MM-dd") + "'T'23:59:59";

                            setOpenLoading(true);
                            const respList = await findProdutividade(
                                values.usuario === "" ? "-1" : values.usuario,
                                dtif,
                                dtff
                            );
                            console.log(respList.data);
                            setList(respList.data);
                            setOpenLoading(false);
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form onSubmit={handleSubmit} className={classes.form}>
                            <div className={classes.boxCenter}>
                                <Paper className={classes.box} elevation={7}>
                                    <Loading open={openLoading} />
                                    <ShowMessageBox
                                        open={openSnackBar}
                                        setOpen={setOpenSnackBar}
                                        severity={severity}
                                        msg={msg}
                                    />

                                    <div className={classes.dashboard_header}>
                                        {/* <div className={classes.center_data_1}>
                      <div>
                        <div>
                          <h2 style={{ color: "white" }}>Produtividade</h2>
                        </div>
                        <div>
                          <h3 style={{ color: "white" }}>
                            <HourglassEmptyIcon /> Listar Por
                          </h3>
                        </div>
                      </div>
                    </div> */}

                                        <div className={classes.center_data_2}>
                                            <div className={classes.center_data}>
                                                <div className={classes.center_data}>
                                                    <InputLabel
                                                        id="label-usuarios"
                                                        style={{ marginRight: "20px" }}
                                                    >
                                                        Operadores
                                                    </InputLabel>
                                                    <Select
                                                        labelId="label-usuarios"
                                                        id="usuario"
                                                        name="usuario"
                                                        value={values.opeId}
                                                        style={{
                                                            width: "250px",
                                                            marginRight: "20px",
                                                            marginLeft: "10px",
                                                        }}
                                                        onChange={handleChange}
                                                    >
                                                        {listUsuarios.map((option) => (
                                                            <MenuItem
                                                                key={option.usu_id}
                                                                value={option.usu_id}
                                                            >
                                                                {option.usu_apelido}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    {/* <span style={{ marginRight: "20px" }}>Período:</span> */}
                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            id="dataInicial"
                                                            name="dataInicial"
                                                            value={values.dataInicial}
                                                            onChange={(val) => {
                                                                setFieldValue("dataInicial", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <MuiPickersUtilsProvider
                                                        locale={ptBR2}
                                                        utils={DateFnsUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            format="dd/MM/yyyy"
                                                            value={values.dataFinal}
                                                            style={{ width: "150px", marginRight: "30px" }}
                                                            id="dataFinal"
                                                            name="dataFinal"
                                                            onChange={(val) => {
                                                                setFieldValue("dataFinal", val);
                                                            }}
                                                            onBlur={handleBlur}
                                                            KeyboardButtonProps={{
                                                                "aria-label": "change date",
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        type="submit"
                                                        style={{ marginTop: "9px", fontWeight: "bold" }}
                                                    >
                                                        Filtrar
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.boxPrancheta}>
                                        <div className={classes.boxDataGridProdutividade}>
                                            <ThemeProvider theme={theme}>
                                                <DataGrid
                                                    rows={list}
                                                    pageSize={8}
                                                    rowHeight={30}
                                                    disableColumnMenu
                                                    disableColumnReorder
                                                    disableSelectionOnClick
                                                    components={{
                                                        Toolbar: CustomToolbar,
                                                    }}
                                                    columns={[
                                                        {
                                                            field: "apelido",
                                                            headerName: "Operador",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "left",
                                                            width: 300,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "data_conclusao",
                                                            headerName: "Data",
                                                            headerClassName: "header_grid",
                                                            type: "date",
                                                            headerAlign: "center",
                                                            width: 100,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "total",
                                                            headerName: "Total",
                                                            headerClassName: "header_grid",
                                                            type: "date",
                                                            headerAlign: "center",
                                                            width: 147,
                                                            sortable: false,
                                                            align: "right",
                                                        },
                                                    ]}
                                                />
                                            </ThemeProvider>
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        </form>
                    )}
                </Formik>
            );
        };

        function a11yProps(index) {
            return {
                id: `tab-${index}`,
                "aria-controls": `tabpanel-${index}`,
            };
        }

        const handleChange = (event, newValue) => {
            setList([]);
            setValue(newValue);
        };

        return (
            <div className={classes.boxCenter}>
                <Paper className={classes.box} elevation={7}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="simple tabs example"
                        style={{ background: "#191970", color: "white" }}
                    >
                        <Tab label="Entradas & Saídas" {...a11yProps(0)} />
                        <Tab label="Tempo Médio Análise" {...a11yProps(1)} />
                        <Tab label="Tempo Médio Veredito" {...a11yProps(2)} />
                        <Tab label="Divergência Veredito" {...a11yProps(3)} />
                        <Tab label="Divergência IA" {...a11yProps(4)} />
                        <Tab label="Relatório Operadores" {...a11yProps(5)} />
                        <Tab label="Produtividade" {...a11yProps(6)} />
                    </Tabs>
                    <TabPanel value={value} index={0}>
                        {TabEntradaXSaidas()}
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        {TabTempoMedioAnalise()}
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        {TabTempoMedioVeredito()}
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        {TabDivergenciaVeredito()}
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                        {TabDivergenciaIA()}
                    </TabPanel>
                    <TabPanel value={value} index={5}>
                        {TabRelatorioOperadores()}
                    </TabPanel>
                    <TabPanel value={value} index={6}>
                        {TabProdutividade()}
                    </TabPanel>
                </Paper>
            </div>
        );
    };

    return (
        <Fragment>
            <Pagina authState={authState} Content={Content} HeaderDesc="KPI" />
        </Fragment>
    );
}
